import normalize from "app/utils/normalize";
import React from "react";
import Svg, { Path } from "react-native-svg";

const FillLikeIcon = ({
  height = normalize(16),
  width = normalize(16),
  color,
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 16 16"
    {...props}
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99722 3.16726C7.09428 2.95234 7.30823 2.81421 7.54404 2.81421C8.13129 2.81421 8.69638 3.0437 9.11451 3.45519C9.53297 3.867 9.76984 4.4276 9.76984 5.0142V6.54752H12.2342C12.4756 6.54536 12.7148 6.59457 12.9357 6.69212C13.1577 6.79018 13.3562 6.93491 13.517 7.1169C13.6778 7.29893 13.797 7.51383 13.8658 7.74694C13.9346 7.98009 13.9511 8.22538 13.914 8.46563L13.9139 8.46655L13.1662 13.2655L13.1661 13.2662C13.1043 13.6659 12.8983 14.028 12.5885 14.2872C12.2798 14.5454 11.8885 14.6844 11.4864 14.6808H3.75052C3.307 14.6808 2.87975 14.5075 2.56325 14.196C2.24643 13.8842 2.06665 13.4593 2.06665 13.0141V9.28084C2.06665 8.83569 2.24643 8.41074 2.56325 8.09895C2.87975 7.78748 3.307 7.61418 3.75052 7.61418H4.98893L6.99722 3.16726Z"
      fill={color}
    />
  </Svg>
);

export default FillLikeIcon;
